import { memo, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { MenuItem, NAVI } from '@constants/navi';
import { SubscriptionsListDropdown } from '@modules/dashboard/components/subscription-list/SubscriptionListDropdown';
import { UserProfileDropdown } from '@modules/dashboard/components/user-profile/UserProfileDropdown';
import { getPetSelector } from '@modules/subscriptions/core/selectors';
import { getHasUpsellDiscountSelector } from '@modules/shop/core/selectors';
import { KTSVG, toAbsoluteUrl } from '@helpers/index';
import { useLayout } from '@layout/core';
import { CampaignBanner } from '@shared/components/campaign-banner/CampaignBanner';

export const HeaderWrapper = memo(function HeaderWrapper() {
  const location = useLocation();
  const intl = useIntl();

  const { classes, attributes } = useLayout();

  const pet = useSelector(getPetSelector);
  const hasUpsellDiscount = useSelector(getHasUpsellDiscountSelector);

  const activeMenuItem = NAVI.find((menuItem: MenuItem) => menuItem.to === location.pathname);
  const activeMenuTitleValues = activeMenuItem?.pet ? { petName: pet?.name } : null;

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* <Link
        to="/shop"
        className="black-friday-banner-desktop hidden font-bold lg:flex w-full bg-[#00756c] text-white text-center text-[1.3rem] md:text-[1.6rem] py-4 uppercase tracking-[0.15em] justify-center items-center gap-2 transition-colors ">
        <span>Deine Lieferung erfolgt in der Woche vom 5.-9. Jänner</span>
      </Link> */}
      <div
        id="kt_header"
        className={clsx(
          'justify-between flex md:hidden',
          classes.header.join(' '),
          'lg:items-stretch',
          {
            scrolled,
          },
        )}
        {...attributes.headerMenu}>
        <div className="flex flex-col w-full">
          {/* <Link
            to="/shop"
            className="black-friday-banner-mobile lg:hidden w-full bg-[#00756c] text-white text-center text-[1.3rem] md:text-[1.6rem] py-4 px-[1.5rem] flex items-center justify-center gap-2 transition-colors ">
            <span>Deine Lieferung erfolgt in der Woche vom 5.-9. Jänner</span>
          </Link> */}
          <div className="flex w-full">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center justify-between w-full">
                <Link to="/dashboard">
                  <KTSVG path={toAbsoluteUrl('/media/logos/logo.svg')} className="w-[8rem]" />
                </Link>
                <UserProfileDropdown />
              </div>
            </div>
          </div>
        </div>
      </div>

      {activeMenuItem && (
        <div id="kt_subheader" className="hidden md:block">
          <div className="lg:grow flex items-end lg:pl-[68px] pb-[40px]">
            <div className="items-stretch flex-shrink-0 hidden subheader-title">
              {intl.formatMessage({ id: activeMenuItem?.title }, { ...activeMenuTitleValues })}
            </div>
            <Link to="/dashboard" className="md:mr-[25px] lg:mr-[95px]">
              <KTSVG path="/media/logos/logo-green-new.svg" className="w-[94px] block h-[54px]" />
            </Link>
            <div className="flex justify-between w-full items-end">
              <SubscriptionsListDropdown />
              {/* `hasUpsellDiscount` is checked out here, not inside CampaignBanner:
                  this wrapper is a flex item of a `justify-between` row, so a
                  self-emptying banner would still take up a slot and push the
                  profile dropdown off its edge. */}
              {location.pathname === '/mitbestellen' && hasUpsellDiscount && (
                <div className="hidden xlup:block mb-[-27px]">
                  <CampaignBanner />
                </div>
              )}
              <UserProfileDropdown />
            </div>
          </div>
        </div>
      )}
    </>
  );
});
HeaderWrapper.displayName = 'HeaderWrapper';
